module.exports = __webpack_public_path__ + "static/media/Assets-06-Books-of-type-04.74ebebd2.png";